<template>
    <div>
        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-3">События</h4>
                        <div class="row align-items-center">
                            <!-- Table -->
                            <div class="table-responsive mb-0">
                                <b-table :busy.sync="isBusy" :items="loadEvents" :fields="fields" responsive="sm"
                                    :per-page="perPage" :current-page="currentPage" ref="connections_table">
                                    <template #cell(client_ip)="data">
                                        {{ data.value }} 
                                    </template>
                                    <template #cell(client_country)="data">
                                        {{ data.value }} <img v-if="data.item.client_iso.length" style="vertical-align: baseline;" height="15"
                                            :src="`/flags/` + data.item.client_iso + `.svg`">
                                    </template>
                                    <template #cell(raw)="data">
                                        <pre>{{ data.value }} </pre>
                                    </template>
                                </b-table>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="dataTables_paginate paging_simple_numbers float-right">
                                        <ul class="pagination pagination-rounded mb-0">
                                            <b-pagination v-model="currentPage" :total-rows="total_connections"
                                                :per-page="perPage"></b-pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- end row -->
                    </div>
                    <!-- end card-body-->
                </div>
                <!-- end card-->
            </div>
            <!-- end col-->
        </div>
    </div>
</template>


<script>
import Portlet from "@src/components/Portlet.vue";
import simplebar from 'simplebar-vue';
import axios from 'axios';
import { humanFileSize, timeAgo } from "@src/utils"


const tableData = [];
export default {
    components: { Portlet, simplebar,  },
    data() {
        return {
            tunnel: {},
            tunnel_stat: [],
            filter: "",

            series: [],

            isBusy: false,
            tableData: tableData,
            title: 'Advanced Table',
            loadInterval: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            total_connections: 0,
            filterOn: [],
            sortBy: 'age',
            sortDesc: false,
            connections: [],
            fields: [{
                key: 'date',
                sortable: true
            },
            {
                key: 'tag',
                sortable: false
            },
            {
                key: 'client_ip',
                // sortable: true
            },
            {
                key: 'client_country',
                // sortable: true
            },
            {
                key: 'raw',
                //sortable: true
            }],
        };
    },
    created() {
        
    },
    computed: {
        lastActivityAgo() {
            return timeAgo(this.tunnel.last_activity)
        },
        targetState() {
            return this.target.length > 0 ? true : false;
        },
    },
    beforeMount() {
        // this.loadProjectInfo();
    },
    mounted() {
    
        // this.loadTunnelStat()
    },
    watch: {
        // currentPage:{
        //     handler(){
        //         this.loadEvents()
        //     }
        // },

    },

    methods: {
        handleOK(evt) {
            evt.preventDefault();
            this.handleAddTarget();
        },
        handleAddTarget() {
            if (!this.checkFormValidity()) {
                return;
            }
            this.addNewTarget();
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity();
            return valid;
        },

        async loadEvents() {
            let that = this
            // this.isBusy = false
            let records = []
            try {
                // that.isBusy = false
                // const response = await axios.get(`/api/secure/wh/tunnels/connections/?tunnel=${this.tunnel.hash}&page=${this.currentPage}&size=${this.perPage}`)
                const response = await axios.get(`https://radar-api.vikingo.org/api/v1/events/`)
                that.total_connections = response.data.total
                records = response.data.records
            }
            catch (error) {
                // this.isBusy = false
            }
            // this.$refs.connections_table.refresh()
            this.connections = records
            return records
        }

    }
};
</script>
<style>
.selectedItem {
    background: #f1f5f7;
}

.tunnel-status {
    position: absolute;
    height: 13px;
    width: 13px;
    background-color: #ced4da;
    border: 2.5px solid #fff;
    border-radius: 50%;
    bottom: 0;
    left: 30px;
}

.tunnel-status.online {
    background-color: #1abc9c;
}

.tunnel-status.offline {
    background-color: #f1556c;
}
</style>